import React, { Component } from 'react';

const MultiSelectFilterButton = (props) => {
    const { filter, index } = props;
    const getSelectedClass = () => {
      return (props.selected[props.index]?'selected':'');
    };
    return (
      <li className={`makeFlex perfectCenter mRight8 borderRadius4 paddingLR9 ${getSelectedClass()}`} onClick={() => props.toggleMultiSelected(props.index)}>
        {filter.icon && <span className={`walletSprite spriteIcon16 spriteIcon24 mRight6 ${filter.icon}`}></span>}
        <p className="text16 latoRegular">{filter.name}</p>
      </li>
    );
  }
  export default MultiSelectFilterButton;
